export default {"src":"/_next/static/media/icon-back-button.8d772549.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};